import { useApi } from '@omnipresentgroup/api';
import { useAuth } from '@omnipresentgroup/auth';
import type { User } from '@omnipresentgroup/types';
import { useQuery } from '@tanstack/react-query';

import { API_BASE, API_PATH } from '../constants';

export const useUser = (id?: string) => {
  const { GET } = useApi();
  const { user } = useAuth();

  const userId = id || user?.sub;

  return useQuery({
    queryKey: [API_PATH, userId],
    queryFn: userId
      ? () => GET<User>(`${API_BASE}/${API_PATH}/${encodeURIComponent(userId)}`)
      : () => Promise.resolve(null),
    enabled: !!userId,
    staleTime: Number.POSITIVE_INFINITY,
  });
};
